module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-report-4.4fe6afe6.svg";